import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export const inArrayValidator = (array: any[]): ValidatorFn => {
  return (control: AbstractControl): ValidationErrors | null => {
    const value = control.value;

    if (!value) {
      return null;
    }

    return array.includes(value)
      ? null
      : { inArray: { value, validValues: array } };
  };
};

/** Custom password strength validator */
export const getPasswordStrengthValidator = (optional = false): ValidatorFn => {
  return (control: AbstractControl): ValidationErrors | null => {
    const value = control.value;
    // Allow empty password if optional
    if (optional && !value) {
      return null;
    }

    const isAtLeast8CharsLong = value.length > 7;
    const hasUpperCase = /[A-Z]+/.test(value);
    const hasLowerCase = /[a-z]+/.test(value);
    const hasNumeric = /[0-9]+/.test(value);
    const hasSymbol = /[!@#$%^&*()_+]+/.test(value);

    const passwordValid =
      isAtLeast8CharsLong &&
      hasUpperCase &&
      hasLowerCase &&
      hasNumeric &&
      hasSymbol;
    // const passwordValid = isAtLeast8CharsLong;

    if (passwordValid) return null;

    const errors: ValidationErrors = {};

    if (!isAtLeast8CharsLong) errors.isLessThan8CharsLong = true;
    if (!hasUpperCase) errors.isMissingUpperCase = true;
    if (!hasLowerCase) errors.isMissingLowerCase = true;
    if (!hasNumeric) errors.isMissingNumber = true;
    if (!hasSymbol) errors.isMissingSymbol = true;

    return errors;
  };
};

/** Custom validator to check if control value matches another control's value */
export const matchesValidator = (
  controlToMatch: AbstractControl,
): ValidatorFn => {
  return (control: AbstractControl): ValidationErrors | null => {
    // Both empty is valid
    if (!control.value && !controlToMatch.value) {
      return null;
    }

    // If either has a value, both must have matching values
    if (
      (!control.value && controlToMatch.value) ||
      (control.value && !controlToMatch.value)
    ) {
      return {
        matches: { value: control.value, expectedValue: controlToMatch.value },
      };
    }

    // If both have values, they must match
    return control.value === controlToMatch.value
      ? null
      : {
          matches: {
            value: control.value,
            expectedValue: controlToMatch.value,
          },
        };
  };
};
